export default {
    auditTab: {
        actionCreated: 'Stvoreno',
        actionAmended: 'Izmijenjeno',
        actionStatus: 'Status',
        secondsAgo: 'prije {n}s',
        minutesAgo: 'prije {n}m',
        hoursAgo: 'prije {n}h',
        daysAgo: 'prije {n}d',
        loadingHistory: 'Učitavanje povijesti revizije…',
        loadFailed: 'Neuspješno učitavanje povijesti revizije.',
        empty: 'Još nema povijesti revizije za ovaj ugovor.',
        headerWhen: 'Kada',
        headerAction: 'Radnja',
        headerStatusChange: 'Promjena statusa',
        headerActor: 'Izvršitelj',
        headerDetails: 'Detalji',
        showDiff: 'Prikaži razlike',
        hideDiff: 'Sakrij razlike',
        before: 'Prije',
        after: 'Poslije',
    },
}
